/** Shared typography for legal pages (privacy policy, cookie policy). */

export const H2 = ({ children }: { children: React.ReactNode }) => (
  <h2 className="mt-10 text-xl md:text-2xl font-bold text-brand">{children}</h2>
);

export const P = ({ children }: { children: React.ReactNode }) => (
  <p className="mt-4 text-gray-700 leading-relaxed">{children}</p>
);

export const UL = ({ items }: { items: string[] }) => (
  <ul className="mt-3 list-disc pl-6 space-y-1 text-gray-700">
    {items.map((it) => (
      <li key={it}>{it}</li>
    ))}
  </ul>
);
